<template>
  <div>
    <md-card class="main_card">
      <md-card-header>
        <div class="md-title">
          Product Crafter
          <md-progress-spinner
            v-show="loading"
            :md-diameter="13"
            :md-stroke="2"
            md-mode="indeterminate"
          />
        </div>
      </md-card-header>
      <md-card-content>
        <form novalidate @submit.prevent="validateForm">
          <div class="md-layout md-gutter">
            <div class="md-layout-item md-small-size-100">
              <div class="md-layout md-gutter">
                <div class="md-layout-item">
                  <md-field :class="getValidationClass('url')">
                    <label for="url">Product Link (URL)</label>
                    <md-input
                      name="url"
                      id="url"
                      v-model="form.url"
                      :disabled="loading"
                      @change="scrapProduct()"
                    />
                    <span class="md-error" v-if="!$v.form.url.required">The Product Link is required</span>
                  </md-field>
                </div>
                <div class="md-layout-item">
                  <md-field :class="getValidationClass('name')">
                    <label for="name">Product Name</label>
                    <md-input name="name" id="name" v-model="form.name" :disabled="loading"></md-input>
                    <span class="md-error" v-if="!$v.form.url.required">The Product Name is required</span>
                  </md-field>
                </div>
              </div>
              <div class="md-layout md-gutter">
                <div class="md-layout-item">
                  <md-field>
                    <label for="detail">Detail (Optional)</label>
                    <md-textarea v-model="form.detail" md-autogrow></md-textarea>
                  </md-field>
                </div>
              </div>
              <div class="md-layout md-gutter">
                <div class="md-layout-item">
                  <md-field>
                    <label for="price">Price</label>
                    <span class="md-prefix">$</span>
                    <md-input name="price" type="number" v-model="form.price"></md-input>
                  </md-field>
                </div>
                <div class="md-layout-item">
                  <md-field>
                    <label for="volumetric">Volumetric</label>
                    <md-select
                      v-model="form.volumetric"
                      :disabled="form.volumetric == 'NA'"
                      name="volumetric"
                      id="volumetric"
                    >
                      <md-option
                        v-for="v in categoryVolumetricMap[form.category]"
                        v-bind:key="v"
                        v-bind:value="v"
                      >{{v}}</md-option>
                    </md-select>
                  </md-field>
                </div>
                <div class="md-layout-item">
                  <md-field>
                    <label for="amount">Amount</label>
                    <md-input name="amount" type="number" min="1" max="5" v-model="form.amount"></md-input>
                  </md-field>
                </div>
              </div>
              <div class="md-layout md-gutter">
                <div class="md-layout-item">
                  <md-field>
                    <label for="category">Category</label>
                    <md-select
                      @md-selected="processCategory()"
                      v-model="form.category"
                      name="category"
                      id="category"
                    >
                      <md-option
                        v-for="category in categories"
                        v-bind:key="category.id"
                        v-bind:value="category.id"
                      >{{category.name}}</md-option>
                    </md-select>
                  </md-field>
                </div>
                <div class="md-layout-item">
                  <md-checkbox
                    v-model="form.originalPackaging"
                    :disabled="!categoryOriginalPackagingMap[form.category]"
                  >{{form.originalPackaging?'With Box':'Without Box'}}</md-checkbox>
                </div>
                <div class="md-layout-item">
                  <md-field>
                    <label for="shipping">Shipping</label>
                    <span class="md-prefix">$</span>
                    <md-input name="shipping" type="number" v-model="form.shipping"></md-input>
                  </md-field>
                </div>
              </div>
            </div>
            <div class="md-layout-item">
              <img class="product-image" v-bind:src="form.image" alt="Product Image" />
              <md-field>
                <label for="image">Image Url</label>
                <md-input name="image" id="image" v-model="form.image" :disabled="loading"></md-input>
              </md-field>
            </div>
          </div>
          <div class="md-layout md-gutter">
            <div class="md-layout-item">
              <md-field>
                <label for="utm_source">UTM Campaign Source</label>
                <md-input
                  name="utm_source"
                  id="utm_source"
                  v-model="form.utm_source"
                  :disabled="loading"
                ></md-input>
              </md-field>
            </div>
            <div class="md-layout-item">
              <md-field>
                <label for="utm_medium">UTM Campaign Medium</label>
                <md-input
                  name="utm_medium"
                  id="utm_medium"
                  v-model="form.utm_medium"
                  :disabled="loading"
                ></md-input>
              </md-field>
            </div>
            <div class="md-layout-item">
              <md-field>
                <label for="utm_name">UTM Campaign Name</label>
                <md-input name="utm_name" id="utm_name" v-model="form.utm_name" :disabled="loading"></md-input>
              </md-field>
            </div>
          </div>
        </form>
      </md-card-content>
      <md-snackbar md-position="center" :md-active.sync="showSnackbar" md-persistent>
        <span>{{snackbar_message}}</span>
        <md-button class="md-primary" @click="showSnackbar = false">Ok</md-button>
      </md-snackbar>
      <md-card-actions>
        <md-button class="md-accent" @click="clearForm()">Clean Form</md-button>
        <md-button class="md-primary" @click="validateForm()">Create Product Link</md-button>
      </md-card-actions>
    </md-card>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import Axios from "axios";

export default {
  name: "Crafter",
  components: {},
  mixins: [validationMixin],
  data() {
    Axios.get(process.env.VUE_APP_API_META_ITEM_CATEGORIES).then(resp => {
      this.categories = resp.data.map(x => ({
        id: x.id,
        name: x.name,
        seoUrl: x.seoUrl
      }));
      resp.data.forEach(element => {
        this.categoryOriginalPackagingMap[element.id] =
          element.originalPackagingSelectable;
        this.categoryVolumetricMap[element.id] = element.volumeTiers.map(
          x => x.code
        );
      });
    });
    return {
      form: {
        url: null,
        name: null,
        image: "https://placekitten.com/200/200",
        volumetric: "NA",
        amount: 1,
        price: 0.0,
        shipping: 0.0,
        category: 1,
        originalPackaging: false,
        utm_name: "support",
        utm_medium: "direct_contact",
        utm_source: "QempoCrafter"
      },
      showSnackbar: false,
      snackbar_message: "hola",
      loading: false,
      categories: [],
      categoryOriginalPackagingMap: {},
      categoryVolumetricMap: {},
      volumetricMap: {
        NA: 0,
        XS: 1,
        S: 2,
        M: 3,
        L: 4,
        XL: 5
      }
    };
  },
  validations: {
    form: {
      url: {
        required
      },
      name: {
        required
      },
      price: {
        required
      },
      volumetric: {
        required
      },
      amount: {
        required
      },
      category: {
        required
      },
      originalPackaging: {
        required
      },
      shipping: {
        required
      }
    }
  },
  methods: {
    getValidationClass(fieldName) {
      const field = this.$v.form[fieldName];

      if (field) {
        return {
          "md-invalid": field.$invalid && field.$dirty
        };
      }
    },
    processCategory() {
      this.form.originalPackaging = false;
      this.form.volumetric = this.categoryVolumetricMap[this.form.category][0];
    },
    clearForm() {
      this.$v.$reset();
      this.form = {
        url: null,
        name: null,
        image: "https://placekitten.com/200/200",
        volumetric: "NA",
        amount: 1,
        price: 0.0,
        shipping: 0.0,
        category: 1,
        originalPackaging: false,
        utm_name: "support",
        utm_medium: "direct_contact",
        utm_source: "QempoCrafter"
      };
    },
    async scrapProduct() {
      if (!this.loading) {
        this.loading = true;
        try {
          const resp = await Axios.get(
            `${process.env.VUE_APP_API_SCRAP_PRODUCT}?url=${encodeURIComponent(this.form.url)}`
          );
          this.form.category = resp.data.categoryId;
          this.form.image = resp.data.image;
          this.form.name = resp.data.name;
          this.form.price = parseFloat(resp.data.price);
          this.form.shipping = parseFloat(resp.data.shipping||0);
          this.showSnackbar = true;
          this.snackbar_message = `Scrapping Successfull: ${this.form.name}`;
        } catch (err) {
          const oldUrl = this.form.url;
          this.showSnackbar = true;
          this.snackbar_message = err;
          this.clearForm();
          this.form.url = oldUrl;
        } finally {
          this.loading = false;
        }
      }
    },
    async generateProductLink() {
      let product = {
        url: this.form.url,
        name: this.form.name,
        detail: this.form.detail,
        image: this.form.image,
        price: `${this.form.price}`,
        amount: this.form.amount,
        categoryId: this.form.category,
        shipping: `${this.form.shipping}`
      };
      if (this.categoryOriginalPackagingMap[this.form.category]) {
        product.originalPackaging = this.form.originalPackaging;
      }
      if (this.form.volumetric != "NA") {
        product.volumeTier = this.form.volumetric;
      }
      const longUrl = `https://www.qempo.com/new-order/product?product=${encodeURIComponent(
        btoa(unescape(encodeURIComponent(JSON.stringify(product))))
      )}&utm_source=${this.form.utm_source}&utm_medium=${
        this.form.utm_medium
      }&utm_campaign=${this.form.utm_campaign}`;
      const bitly_token = "743896dbd9f1279257ebf357388894b7d457d109";
      this.loading = true;
      try {
        const resp = await Axios.post(
          process.env.VUE_APP_API_BITLY_BITLINKS,
          {
            long_url: longUrl
          },
          {
            headers: {
              Authorization: `Bearer ${bitly_token}`,
              "Content-Type": "application/json"
            }
          }
        );
        this.copyTextToClipboard(resp.data.link);
        this.showSnackbar = true;
        this.snackbar_message = `Link Generated: ${resp.data.link}`;
        this.clearForm();
      } catch (error) {
        this.showSnackbar = true;
        this.snackbar_message = error;
      } finally {
        this.loading = false;
      }
    },
    validateForm() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.generateProductLink();
      }
    },
    copyTextToClipboard(text) {
      if (!navigator.clipboard) {
        this.fallbackCopyTextToClipboard(text);
        return;
      }
      navigator.clipboard.writeText(text).then(
        function() {},
        function(err) {
          console.error("Async: Could not copy text: ", err);
        }
      );
    },
    fallbackCopyTextToClipboard(text) {
      var textArea = document.createElement("textarea");
      textArea.value = text;
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      try {
        var successful = document.execCommand("copy");
        if (!successful) {
          throw Error("Could not copy to clipboard");
        }
      } catch (err) {
        console.error("Fallback: Oops, unable to copy", err);
      }
      document.body.removeChild(textArea);
    }
  }
};
</script>

<style>
.main_card {
  max-width: 1400px;
}
.product-image {
  max-height: 200px;
  max-width: 200px;
  display: block;
  margin: auto;
}
</style>